import * as C from 'actions/constants';

export const blankState = {
  data: [],
  meta: {},
  loading: false,
  queryParams: {},
};

const GalleryReducer = (state = blankState, action) => {
  switch (action.type) {
    case C.LOAD_GALLERY: {
      return { ...state, loading: true };
    }
    case C.LOAD_GALLERY_SUCCESS: {
      const { data, meta, queryParams } = action;
      return {
        ...state,
        data,
        meta,
        queryParams,
        loading: false,
      };
    }
    case C.LOAD_GALLERY_ERROR: {
      return { ...state, loading: false };
    }
    case C.CLOSE_REPORT: {
      return blankState;
    }
    default:
      return state;
  }
};

export default GalleryReducer;
